import { z } from "zod";

const RiskCalendarSchema = z.object({
  search: z.string(),
  query: z.any(),
  view: z.string().nullish(),
  timeline: z.string().nullish(),
});

export default RiskCalendarSchema;
